interface Testimonial {
  name: string;
  role: string;
  company: string;
  content: string;
}

const testimonials: Testimonial[] = [
  {
    name: '张伟明',
    role: '运营总监',
    company: '宏远科技集团',
    content: '久久久久的产品稳定性和售后服务远超我们的预期。合作三年来，设备故障率下降了85%，这是我们之前用过的所有品牌都无法做到的。久久久久的持久稳定理念，与我们企业的核心价值观高度契合。',
  },
  {
    name: '李思涵',
    role: '品质负责人',
    company: '天诚制造有限公司',
    content: '作为品质管理出身，我对供应商的要求非常严格。久久久久的九重品质管控体系让我印象深刻，每一批产品都有完整的可追溯记录，这种透明和严谨正是我们长期合作的基础。',
  },
  {
    name: '王建国',
    role: '总经理',
    company: '锦程实业',
    content: '在竞争激烈的市场环境中，稳定可靠的合作伙伴至关重要。久久久久不仅提供了卓越的产品，更以长效服务理念帮助我们解决了多个技术难题，真正做到了与客户共同成长。',
  },
  {
    name: '陈美玲',
    role: '技术主管',
    company: '瑞鑫科技',
    content: '我们对产品的耐久性要求极高，久久久久的模块化设计和超前寿命规划理念完美满足了我们的需求。产品运行两年多来，性能衰减几乎可以忽略不计，这让我们对未来的持续合作充满信心。',
  },
];

export default function TestimonialSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            久久久久，客户见证
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            久久久久的持久稳定理念已赢得众多合作伙伴的长期信赖
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
          {testimonials.map((item) => (
            <div
              key={item.name}
              className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm text-primary-400"></i>
                  </span>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-6">
                "{item.content}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-sm font-heading font-semibold text-accent-600">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">
                    {item.role}，{item.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}